import { render, staticRenderFns } from "./BarcodeScanner.vue?vue&type=template&id=1266cfde&scoped=true"
import script from "./BarcodeScanner.vue?vue&type=script&lang=js"
export * from "./BarcodeScanner.vue?vue&type=script&lang=js"
import style0 from "./BarcodeScanner.vue?vue&type=style&index=0&id=1266cfde&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1266cfde",
  null
  
)

export default component.exports